import React, { FC, RefObject, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, Divider, Grid,TextField, IconButton, MenuItem, Paper, Select, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CancelIcon from '../../../assets/icons/cancel-icon';
import FileUploader from '../../file-loader';
import Table from '../../bulk-device-management/table';
import useStyles from './styles';
import { AppState } from '../../../store';
import { rtdsFilesHeadCells, rtdsFilesHeadCellsSortableAccessors, vimsConfigHeadCells, vimsConfigSortableAccessors } from './head-cell';
import VirtualizedTable from '../../virtualized-table';
import { getBaseSubscriptionManagement, queueConfigManagement, uploadRtdsConfigFile, uploadVimsConfigFile,patchConfigManagement,deleteConfigManagement } from '../../../store/software-library-management/actions';
import { LibraryManagementActionNames } from '../../../store/software-library-management/types';
import { BaseSubsctiptionPlanParameters, ConfigManagementRequestPayload, queueConfigManagementResponse } from '../../../services/types';
import ConfigurationManagement from '../../../services/config-management';
import { setModalOpen } from '../../../store/modal/actions';
import { vimsConfigFileAlreadyExistMessage } from '../messages';
import { enqueueSnackbarAction } from '../../../store/snackbar/actions';

type SelectOption = {
    value: string;
    title: string;
};

const generationOfDevices: SelectOption[] = [
  { value: 'GLOBAL', title: 'PLE/PL542' },
  { value: 'GEN5', title: 'PL542' },
  { value: 'GEN6', title: 'PLE' },
  // { value: 'GEN7', title: 'Gen 7' },
  { value: 'PL444', title: 'PL444' },
];

const setPercentUpload = () => { };

const VIMSAndRTDSConfig: FC = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [rtdsConfigFile, setRtdsConfigFile] = useState<any>();
    const [editRtdsConfigFile, setEditRtdsConfigFile] = useState<any>();
    const [rtdsConfigFileName, setRtdsConfigFileName] = useState<string>();
    const [editRtdsConfigFileName, setEditRtdsConfigFileName] = useState<string>();
    const [generationOfDevice, setgenerationOfDevice] = useState<string>();
    const [baseSubscriptionName, setBaseSubscriptionName] = useState([]);
    const [planName, setPlanName] = useState<string>('');
    const [columnVisibility, setColumnVisibility] = useState([]);
    const [columnOrder, setColumnOrder] = useState([]);
    const tableContainer: RefObject<HTMLDivElement> = useRef(null);
    const [selectedItem, setSelectedItem] = useState<number | null>();
    const [vimsFileName, setVimsFileName] = useState<any>();
    const [vimsSha1, setVimsSha1] = useState<string>();
    const reference = useRef<HTMLInputElement>(null);
    const [existingvimsFileName, setExistingVimsFileName] = useState<{
        id: string;
       fileName:string;
    }>();
    const [vimsConfigReboot, setVimsConfigReboot] = useState<boolean>(false);
    const [rtdsConfigDefault, setRtdsConfigDefault] = useState<boolean>(false);
    const [vimsConfigRebootEdit, setVimsConfigRebootEdit] = useState(false);
    const [rtdsConfigDefaultEdit, setRtdsConfigDefaultEdit] = useState<boolean>(false);
    const [selectFromexist, setSelectFromexist] = useState<boolean>(false); 
    const [originalRtdsConfigDefaultEdit, setOriginalRtdsConfigDefaultEdit] = useState(false);
    const [originalVimsConfigRebootEdit, setOriginalVimsConfigRebootEdit] = useState(false);
    const [vimsConfigFileName, setVimsConfigFileName] = useState<string>('');
    const [vimsConfigFile, setVimsConfigFile] = useState<any>();
    const [vimsConfigFileUploadData, setVimsConfigFileUploadData] = useState<any>([]);
    const [rtdsConfigFileUploadData, setRtdsConfigFileUploadData] = useState<any>([]);
    const [vimsSha, setVimsSha] = useState<string>('');

    const Checkbox = ({ row }: any) => (
        <>
            <input
                type="radio"
                checked={row.id === selectedItem}
                onChange={() => {
                    setSelectedItem(row.id);
                    setExistingVimsFileName({
                        id: row.original.vimsSha1,
                        fileName:row.original.vimsFileName
                    });
                }}
            />
        </>
    );

    const checkColumn = {
        accessor: 'checkbox',
        width: 30,
        Header: '',
        component: Checkbox,
    };

    const vimsTableContainer = useRef<any>();
    const columns = useMemo(() => [checkColumn, ...vimsConfigHeadCells], [checkColumn]);
    const [selectedRows, setSelectedRows] = useState<any>([]);
    const [popoverOpen, setPopoverOpen] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>();

    const [modalData, setModalData] = useState([]);
    const tableData = useSelector((state: AppState) => state.libraryManagement.softwareFiles);
    const vimsShaValue = useSelector(
        (state: AppState) => state.libraryManagement.vimsShaValue,
    );
    const rtdsShaValue = useSelector(
        (state: AppState) => state.libraryManagement.rtdsShaValue,
    );
    const [vimsRtdsTableData, setVimsRtdsTableData] = useState<any[]>([]);
    const [openEditPopUp, setOpenEditPopoUp] = useState<boolean>(false);
    const [deleteSelectedRow, setDeleteSelectedRow] = useState<any>([]);
    const [editSelectedRow, setEditSelectedRow] = useState<any>([]);
    const { client, envVariables } = useSelector((state: AppState) => state.login);
    const clientAuth: any = client?.authenticate();
    const userName = clientAuth?.loginId;
    const fileReader = new FileReader();

    const TableData = {
        title: 'RTDS VIMS Files',
        storageString: 'library-management-rtds-vims-files',
        headerColumns: rtdsFilesHeadCells,
        sortableAccessors: rtdsFilesHeadCellsSortableAccessors,
        onRowSelection: setSelectedRows,
        data: vimsRtdsTableData,
        id: 'rtds-files',
        setColumnVisibility,
        columnVisibility,
        setColumnOrder,
        columnOrder,
        tableContainer,
    };
  const getGenerationDisplayName = (genType: string): string => {
    const generation = generationOfDevices.find((gen) => gen.value === genType);
    return generation ? generation.title : genType;
  };

  const getGenerationValue = (displayName: string): string => {
    const generation = generationOfDevices.find((gen) => gen.title === displayName);
    return generation ? generation.value : displayName;
  };
    const vimsRtdsConfigRepository = useCallback(async (generationOfDevice) => {
    const configurationManagement = new ConfigurationManagement(client, envVariables.configManangementV1BaseUrl);
    const input: ConfigManagementRequestPayload = { generationType: generationOfDevice };
    try {
        const result = await configurationManagement.getConfigurationFiles(input);
        const configData = result?.data?.configs;
        if (Array.isArray(configData) && configData.length > 0) {
            setVimsRtdsTableData(
                configData.flatMap((config: any) =>
                    config.configurations.map((subConfig: any) => ({
                        id: config.vimsSha1,
                        generationType: getGenerationDisplayName(config.generationType),
                        vimsFileName: config.vimsFileName,
                        vimsSha1: config.vimsSha1,
                        vimsConfigId: config.vimsConfigId,
                        fileName: config.vimsFileName,
                        isReboot: config.isReboot,
                        rtdsSha1: subConfig.rtdsSha1,
                        configId: subConfig.configId,
                        isDefault: subConfig.isDefault,
                        subscriptionName: subConfig.subscriptionName,
                        updatedTS: subConfig.updatedTS,
                        updatedBy: subConfig.updatedBy,
                    }))
                )
            );
        } else {
            setVimsRtdsTableData([]);
        }
    } catch (error) {
        setVimsRtdsTableData([]);
        dispatch(
            enqueueSnackbarAction({
                message: 'Failed to fetch configuration files. Please try again.',
                options: { variant: 'error' },
            })
        );
        console.error('Error fetching configuration files:', error);
    }
    return null;
}, [client, envVariables.configManangementV1BaseUrl, dispatch]);

  const uniqueVimsFiles = useMemo(() => {
    const seen = new Set();
    return (vimsRtdsTableData || [])
      .filter((item) => {
        const key = `${item.vimsFileName}|${item.vimsSha1}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      })
      .map((item) => ({
        ...item,
        generationType:
          generationOfDevices.find((gen) => gen.value === item.generationType)?.title || item.generationType,
      }));
  }, [vimsRtdsTableData, generationOfDevices]);

    const onChangeGenerationOfDevice = (event: { target: { value: string } }) => {
      const newValue = event.target.value;
      setgenerationOfDevice(newValue);
      vimsRtdsConfigRepository(newValue);
      if (newValue === 'PL444') {
        setPlanName('');
        setRtdsConfigFile(null);
        setRtdsConfigFileName('');
        setRtdsConfigDefault(false);
      }
    };
    const handleVimsSha = (event: any) => {
    const { value } = event.target;
    setVimsSha(value);
    if (value.trim()) {
      setVimsSha1(value.trim());
      setVimsConfigFile(null);
      setVimsConfigFileName('');
      setSelectFromexist(false);
    } else {
      setVimsSha1(undefined);
      setVimsFileName('');
    }
  };
  // eslint-disable-next-line unicorn/consistent-function-scoping
    const selectVimsConfigFile = () => {
      setSelectFromexist(true);
      setVimsConfigFile(null);
      setVimsConfigFileName('');
      setVimsFileName(existingvimsFileName?.fileName);
      setVimsSha1(existingvimsFileName?.id);
      setVimsSha(existingvimsFileName?.id ?? '');
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      closePopover();
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      resetSelection();
    };
    const getBaseSubscriptionName = async () => {
      const input: BaseSubsctiptionPlanParameters = {
      sortBy: 'planName',
      catalogType: 'subscription',
      limit: 500,
      offset: 0,
      type: 'Base',
      productName: 'New VisionLink',
    } 
      const plans: any = await dispatch(getBaseSubscriptionManagement(input));
      const selectOptions = plans ? plans.filter((f: any) => f.subscribable) : [];
      setBaseSubscriptionName(selectOptions); 
    };

    useEffect(() => {
      getBaseSubscriptionName();
    }, []);

    const closePopover = () => {
        setPopoverOpen(false);
    }
  const handleVimsConfigFileAccept = async () => {
  return new Promise<void>((resolve) => {
    const fileUploadData = {
      file: vimsConfigFile,
      fileName: vimsFileName,
      fileTypeId: '10330',
      overwrite: false,
      setPercentUpload,
      finishedCallback: (response: any) => {
        setVimsConfigFile(null);
        resolve();
      },
    };
    setVimsConfigFileUploadData(fileUploadData);
    dispatch(uploadVimsConfigFile(fileUploadData));
  });
  };

  const handleRtdsConfigFileAccept = async (uploadType: "direct" | "edit") => {
  return new Promise<void>((resolve) => {
  const fileToUpload = uploadType === "direct" ? rtdsConfigFile : editRtdsConfigFile;
  const fileNameToUse = uploadType === "direct" ? rtdsConfigFileName : editRtdsConfigFile;
  const fileUploadData = {
    file: fileToUpload,
    fileName: fileNameToUse,
    fileTypeId: "10237",
    partNumber: "",
    overwrite: false,
    setPercentUpload,
    finishedCallback: (response: any) => {
      setRtdsConfigFile(null); 
      console.log(response, "rtdsresponse");
      resolve();
    },
  };

  setRtdsConfigFileUploadData(fileUploadData);
  dispatch(uploadRtdsConfigFile(fileUploadData)); 
  });
};

const handleRtdsConfigFile = async (file: string | any[],uploadType: "direct" | "edit") => {
  if (!file || !file.length) return;
  const selectedFile = file[0];
  if (!selectedFile.name.endsWith('.json')) {
    dispatch(
      enqueueSnackbarAction({
        message: 'Only Json files are allowed!',
        options: { variant: 'error' },
      }),
    );
    return;
  }
  if (uploadType === "direct") {
    setRtdsConfigFile(file[0]); 
    setRtdsConfigFileName(file[0].name);
  } else if (uploadType === "edit") {
    setEditRtdsConfigFile(file[0]); 
    setEditRtdsConfigFileName(file[0].name);
  }

};
  const handleVimsConfigFile = async(file: any) => {
    if (selectFromexist) {
      setVimsFileName('');
      setVimsSha('');
    }
    setVimsSha1(undefined);
    if (!file || !file.length) return;
    const selectedFile = file[0];
    if (generationOfDevice === 'PL444') {
      setVimsConfigFile(file[0]);
      setVimsConfigFileName(file[0].name);
      setVimsFileName(selectedFile.name.replace(/\.[^./]+$/, ''));
      setVimsSha('');
      setSelectFromexist(false);
    } else {
      if (!selectedFile.name.endsWith('.cfg')) {
        dispatch(
          enqueueSnackbarAction({
            message: 'Only CFG files are allowed for this generation type!',
            options: { variant: 'error' },
          }),
        );
        return;
      }
      setVimsConfigFile(file[0]);
      setVimsConfigFileName(file[0].name);
      setVimsFileName(selectedFile.name.replace(/\.[^./]+$/, ''));
      setVimsSha('');
      setSelectFromexist(false);
    }
  };
    const resetSelection = () => {
        setExistingVimsFileName(undefined);
        setSelectedItem(null);
    };
    const handleChange = (event: any) => {
       // eslint-disable-next-line prefer-destructuring
       let value = event.target.value
        value = value.replace(/^\s+/g, "").replace(/\s{2,}/g, " ");
        setVimsFileName(value); 
    };

    const resetFields = () => {
      setVimsConfigFileName('');
      setVimsConfigFile(null);
      setRtdsConfigFile('');
      setPlanName('');
      setVimsConfigReboot(false);
      setRtdsConfigFile(false);
      setVimsFileName('');
      setRtdsConfigFileName('');
      setRtdsConfigDefault(false);
      setVimsSha(''); 
      setVimsSha1(undefined); 
      setSelectFromexist(false);
    };
   const resetEditFields = () => { 
      setEditRtdsConfigFile('');
      // setVimsConfigRebootEdit(false);
      setEditRtdsConfigFileName('');
      // setRtdsConfigDefaultEdit(false);
    };

    const saveConfigApi = async () => {
      const input: any = {
        generationType: generationOfDevice,
        vimsFileName,
        vimsSha1,
        isReboot: vimsConfigReboot,
        ...(generationOfDevice !== 'PL444' && {
          subscriptionName: planName,
          isDefault: rtdsConfigDefault,
        }),
        finishedCallback: (response: queueConfigManagementResponse) => {
        console.log(response)
       vimsRtdsConfigRepository(generationOfDevice);
       },
        overwriteCallback: () =>
          dispatch(
            setModalOpen({
              open: true,
              message: vimsConfigFileAlreadyExistMessage,
              accept: () => {
                dispatch(
                  queueConfigManagement({
                    ...input,
                    isOverride: true,
                  }),
                );
                dispatch({
                  type: LibraryManagementActionNames.SET_VIMS_FILE_EXISTS,
                  payload: null,
                });
                dispatch({
                  type: LibraryManagementActionNames.SET_RTDS_FILE_EXISTS,
                  payload: null,
                });
              },
              cancel: () => {
                dispatch({
                  type: LibraryManagementActionNames.SET_VIMS_FILE_EXISTS,
                  payload: null,
                });
                dispatch({
                  type: LibraryManagementActionNames.SET_RTDS_FILE_EXISTS,
                  payload: null,
                });
              },
            }),
          ),
      };
      dispatch(queueConfigManagement(input));
    };
    /* eslint-disable unicorn/consistent-function-scoping */

    const saveConfigsActions = async () => {
      try {
       const asyncCalls = [];
       if (!vimsSha1) {
         asyncCalls.push(handleVimsConfigFileAccept());
       }
       if (generationOfDevice !== 'PL444') {
       asyncCalls.push(handleRtdsConfigFileAccept('direct'));
       }
        await Promise.all(asyncCalls);
        await new Promise((resolve) => setTimeout(resolve, 500));
        await saveConfigApi();
      } catch (error) {
        console.error('Error in saveConfigsActions:', error);
      } finally {
        resetFields();
      }
    };

    const handleExistingVimsConfig = () => {
        setPopoverOpen(true);
    }

    const closeEditPopover = () => {
        setOpenEditPopoUp(false);
        resetEditFields()
    }

    const handleEditVimsConfig = (item:any) => {
        setOpenEditPopoUp(true);
        setEditSelectedRow(selectedRows);
        setRtdsConfigDefaultEdit(selectedRows[0].isDefault);
        setVimsConfigRebootEdit(selectedRows[0].isReboot);
        setOriginalRtdsConfigDefaultEdit(selectedRows[0].isDefault); 
        setOriginalVimsConfigRebootEdit(selectedRows[0].isReboot);
    }

    const deleteConfigs = async (configs: any) => {   
      const deleteConfigRequest = {
          configs,
          userId: userName,
          applicationId: 'iot-gateway'
      };
      await dispatch(deleteConfigManagement(deleteConfigRequest));
      vimsRtdsConfigRepository(generationOfDevice);
    };
    const handleDeleteVimsConfig = (item: any) => {
      setDeleteSelectedRow(selectedRows);
      // eslint-disable-next-line array-callback-return
      const configs = selectedRows.map((item: any) => ({
        generationType: getGenerationValue(item.generationType),
        configId: item.configId,
        vimsSha1: item.vimsSha1,
      }));
      deleteConfigs(configs);
    };
    const editConfigManagement = async () => {
      closeEditPopover();
     if(editRtdsConfigFile){
      await handleRtdsConfigFileAccept('edit');
     }
      const queueConfigRequest = {
        configs: [
          {
           generationType: getGenerationValue(editSelectedRow[0].generationType),
            vimsSha1: editSelectedRow[0].vimsSha1,
            isReboot:
                  vimsConfigRebootEdit !== originalVimsConfigRebootEdit
                    ? vimsConfigRebootEdit
                    : editSelectedRow[0].isReboot,
            vimsFileName: editSelectedRow[0].vimsFileName,
            configurations: [
              {
                subscriptionName: editSelectedRow[0].subscriptionName,
                isDefault:
                  rtdsConfigDefaultEdit !== originalRtdsConfigDefaultEdit
                    ? rtdsConfigDefaultEdit
                    : editSelectedRow[0].isDefault,
                rtdsSha1: !editRtdsConfigFile ? editSelectedRow[0].rtdsSha1 : '',
              },
            ],
          },
        ],
        userId: userName,
        applicationId: 'iot-gateway',
      };
      await dispatch(patchConfigManagement(queueConfigRequest));
      vimsRtdsConfigRepository(generationOfDevice);
    };

    return (
      <div className={classes.scrollBox}>
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" gap={6}>
              <Typography variant="h6" sx={{ mr: 1, whiteSpace: 'nowrap' }}>
                Select Gen Type<span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
              </Typography>
              <Select
                variant="standard"
                id="generationDevice"
                value={generationOfDevice}
                onChange={onChangeGenerationOfDevice}
                className={classes.dropdown}
              >
                <MenuItem value="" disabled>
                  <em className={classes.unSelected}>Select</em>
                </MenuItem>
                {(generationOfDevices as Array<SelectOption>).map((o: SelectOption) => (
                  <MenuItem key={o.value} value={o.value}>
                    {o.title}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" gap={7}>
              <Typography variant="h6" sx={{ mr: 1, whiteSpace: 'nowrap' }}>
                VIMS File Name <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
              </Typography>
              <TextField
                variant="standard"
                margin="none"
                className={classes.textField}
                id="vims-file-name-input"
                placeholder={!vimsFileName ? 'File Name*' : ''}
                onChange={handleChange}
                value={vimsFileName}
                title={vimsFileName}
                disabled={!vimsSha.trim() && !vimsConfigFile || selectFromexist}
                required={!vimsConfigFile}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" gap={1}>
              <Box display="flex" alignItems="center" gap={11}>
                <Typography variant="h6" sx={{ whiteSpace: 'nowrap' }}>
                  VIMS Config <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
                </Typography>
                <TextField
                  variant="standard"
                  margin="none"
                  id="vims-sha-input"
                  className={classes.textField}
                  label={vimsSha ? '' : 'VIMS SHA'}
                  onChange={handleVimsSha}
                  value={vimsSha}
                  title={vimsSha}
                  disabled={!!vimsConfigFile || selectFromexist}
                  required
                />
              </Box>
              <Box display="flex" alignItems="center" ml={1} gap={1}>
                <FileUploader
                  text="Select File"
                  buttonId="config-files-upload"
                  handleFile={handleVimsConfigFile}
                  multiple
                  accept={generationOfDevice === 'PL444' ? '*' : '.cfg'}
                  enabled={
                    !!generationOfDevice && (!vimsSha.trim() || selectFromexist || !!vimsConfigFile)
                  }
                />
              </Box>
              <Button
                className={classes.button}
                variant="outlined"
                size="small"
                onClick={() => handleExistingVimsConfig()}
                disabled={
                  !generationOfDevice || (!!vimsSha.trim() && !selectFromexist && !vimsConfigFile)
                }
              >
                SELECT FROM EXISTING FILE
              </Button>
          {generationOfDevice !== 'PL444' && (
            <>
              {/* <input
                type="checkbox"
                checked={rtdsConfigDefault}
                onChange={(event) => setRtdsConfigDefault(event.target.checked as boolean)}
                className={classes.leftAlign}
              />
              <Typography display="inline" sx={{ mr: 1 }}>Is Default Required</Typography>
              <input
                type="checkbox"
                checked={vimsConfigReboot}
                onChange={(event) => setVimsConfigReboot(event.target.checked as boolean)}
                className={classes.leftAlign}
              />
              <Typography display="inline" >Is Reboot Required</Typography> */}
          </> 
        )}
            </Box>
          </Grid>
        {generationOfDevice !== 'PL444' && (
          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Typography variant="h6" sx={{ mr: 6, whiteSpace: 'nowrap' }}>
                Base Subscription<span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
              </Typography>
              <Select
                variant="standard"
                id="Select Base Subscription"
                value={planName}
                onChange={(event) => setPlanName(event.target.value as string)}
                className={classes.dropdown}
                sx={{ minWidth: 200, mr: 3 }}
                fullWidth={false}
              >
                <MenuItem value="" disabled>
                  <em className={classes.unSelected}>Select</em>
                </MenuItem>
                {(baseSubscriptionName as Array<SelectOption>).map((plans: any) => (
                  <MenuItem value={plans.planName} key={plans.planName}>
                    <span title={plans.planName}>{plans.planName}</span>
                  </MenuItem>
                ))}
              </Select>
              {/* RTDS Config label and uploader with NO gap */}
              <Box display="flex" alignItems="center" gap={0}>
                <Typography variant="h6" sx={{ mr: 1, whiteSpace: 'nowrap' }}>
                  RTDS Config<span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
                </Typography>
                {rtdsConfigFile ? (
                  <Typography variant="caption" sx={{ fontSize: '15px', color: '#222', mr: 1 }}>
                    {rtdsConfigFileName}
                  </Typography>
                ) : null}
                <FileUploader
                  text="Select FILE"
                  buttonId="config-files-upload"
                  handleFile={(file: string | any[]) => handleRtdsConfigFile(file, 'direct')}
                  multiple
                  accept=".json, application/json"
                />
              </Box>
            </Box>
          </Grid>
        )}
        </Grid>
        <div className={classes.actionRow}>
          <Button
            className={classes.saveButton}
            variant="outlined"
            size="small"
            onClick={() => saveConfigsActions()}
            disabled={
              !generationOfDevice ||
              !(vimsConfigFile || vimsSha1) ||
              !vimsFileName ||
              (
                generationOfDevice !== 'PL444' &&
                (
                  !rtdsConfigFile ||
                  !baseSubscriptionName
                )
              )
            }
          >
            Save Configs
          </Button>
        </div>
        <Box pt={3}>
          <Typography variant="h6">VIMS/RTDS Config Repository</Typography>
          <div className={classes.actionRow}>
            <Button
              className={classes.button}
              variant="outlined"
              size="small"
              onClick={(item) => handleDeleteVimsConfig(item)}
              disabled={!selectedRows?.length}
            >
              Delete Selected
            </Button>
            <Button
              className={classes.button}
              variant="outlined"
              size="small"
              onClick={(item) => handleEditVimsConfig(item)}
              disabled={!selectedRows?.length}
            >
              Edit Selected
            </Button>
          </div>
        </Box>
        <div ref={tableContainer} className={classes.tableContainer}>
          <Table {...TableData} />
        </div>
        <Dialog
          open={popoverOpen}
          PaperProps={{
            style: {
              overflow: 'auto',
              minWidth: 700,
              width: 900,
              maxWidth: '95vw',
              maxHeight: '90vh',
            },
          }}
          PaperComponent={Paper}
          className={classes.dialog}
          maxWidth={false}
        >
          <Paper elevation={24}>
            <DialogContent>
              <Box p={2}>
                <Box pb={2}>
                  <Typography variant="h6" mb={1}>
                    VIMS Config List
                  </Typography>
                  <Divider />
                  {/* {modalData && ( */}
                  <div ref={vimsTableContainer} className={classes.vimsTableContainer}>
                    <VirtualizedTable
                      sortableAccessors={vimsConfigSortableAccessors}
                      columns={columns}
                      data={uniqueVimsFiles}
                      itemCount={uniqueVimsFiles.length}
                      tableContainer={vimsTableContainer}
                      loading={isLoading}
                    />
                  </div>
                  {/* )} */}
                </Box>
                <Box
                  display="flex"
                  flexGrow={1}
                  alignItems="center"
                  justifyContent="flex-end"
                  pr={2}
                >
                  {selectedItem && (
                    <>
                      <Box px={1}>
                        <Typography variant="h6">Selected Configs:</Typography>
                      </Box>
                      <Box px={1} flexGrow={0} overflow="hidden">
                        <Typography className={classes.overFlowEllipsis}>{selectedItem}</Typography>
                      </Box>
                      <Box px={1} pr={2}>
                        <IconButton
                          className={classes.iconButton}
                          id="queue-files-delete-selection"
                          onClick={() => resetSelection()}
                          aria-label="edit"
                          size="large"
                        >
                          <CancelIcon />
                        </IconButton>
                      </Box>
                    </>
                  )}
                  <DialogActions>
                    <Button
                      onClick={() => closePopover()}
                      variant="outlined"
                      size="small"
                      color="primary"
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={(item) => selectVimsConfigFile()}
                      variant="outlined"
                      size="small"
                      color="primary"
                      endIcon
                      disabled={!selectedItem}
                    >
                      Select Vims Config File
                    </Button>
                  </DialogActions>
                </Box>
              </Box>
            </DialogContent>
          </Paper>
        </Dialog>

        <Dialog
          open={openEditPopUp}
          PaperComponent={Paper}
          className={classes.dialog}
          maxWidth="lg"
        >
          <Paper elevation={24}>
            <DialogContent>
              <Box p={2}>
                <Grid container direction="row" alignItems="stretch" mt="20px">
                  <Grid item xs={12}>
                    <Box className={classes.box} mt="15px">
                      <Typography variant="h6">Gen Type:</Typography>
                      <Typography className={classes.leftAlign}>
                        {selectedRows[0]?.generationType}
                      </Typography>

                      <Typography variant="h6" className={classes.leftAlign}>
                        VIMS Config:
                      </Typography>
                      <Typography className={classes.leftAlign}>
                        {selectedRows[0]?.vimsFileName}
                      </Typography>

                      <Typography variant="h6" className={classes.leftAlign}>
                        Base Subscription:
                      </Typography>
                      <Typography className={classes.leftAlign}>
                        {selectedRows[0]?.subscriptionName}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch" mt="20px">
                  <Grid item xs={12}>
                    <Box className={classes.box} mt="15px">
                      <Typography variant="h6" mr="10px">
                        RTDS Config
                      </Typography>
                      {selectedRows?.length > 0 && (
                        <Typography style={{ marginRight: '10px' }}>
                          {editRtdsConfigFileName}
                        </Typography>
                      )}
                      <FileUploader
                        text="Select FILE"
                        buttonId="config-files-upload"
                        handleFile={(file: string | any[]) => handleRtdsConfigFile(file, 'edit')}
                        multiple
                        accept=".json, application/json"
                      />
                      {/* <input
                        type="checkbox"
                        checked={rtdsConfigDefaultEdit}
                        onChange={(event) => {
                          setRtdsConfigDefaultEdit(event.target.checked as boolean);
                        }}
                        className={classes.leftAlign}
                      /> */}
                      {/* <Typography>Is Default Required</Typography>
                      <input
                        type="checkbox"
                        checked={vimsConfigRebootEdit}
                        onChange={(event) => {
                          setVimsConfigRebootEdit(event.target.checked as boolean); 
                        }}
                        className={classes.leftAlign}
                      />
                      <Typography>Is Reboot Required</Typography> */}
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              <DialogActions>
                <Button
                  onClick={() => closeEditPopover()}
                  variant="outlined"
                  size="small"
                  color="primary"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => editConfigManagement()}
                  variant="outlined"
                  size="small"
                  color="primary"
                  endIcon
                  disabled={!editRtdsConfigFile && vimsConfigRebootEdit === originalVimsConfigRebootEdit && rtdsConfigDefaultEdit === originalRtdsConfigDefaultEdit}
                >
                  Edit
                </Button>
              </DialogActions>
            </DialogContent>
          </Paper>
        </Dialog>
      </div>
    );
};

export default VIMSAndRTDSConfig;
